import React, { useEffect, useState } from 'react';
import { List, X } from 'react-bootstrap-icons';

const LINKS = [
  { href: '#capabilities', label: 'What it does' },
  { href: '#live', label: 'Live mode' },
  { href: '#how-it-works', label: 'How it works' },
  { href: '#examples', label: 'Examples' },
];

export default function LandingNav({ onSignIn }) {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const go = (href) => {
    setOpen(false);
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  return (
    <header
      className={`sticky top-0 z-50 w-full transition-shadow ${
        scrolled ? 'bg-white/95 shadow-brand-sm backdrop-blur' : 'bg-white'
      }`}
    >
      <div className="mx-auto flex max-w-landing items-center justify-between gap-4 px-4 py-3 sm:px-6 lg:px-8">
        <a href="#top" className="flex shrink-0 items-center" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>
          <img
            src="/static/images/logo-mark-navy.png"
            alt="SchoolCracked"
            className="h-9 w-auto object-contain sm:h-10"
          />
        </a>

        <nav className="hidden items-center gap-8 md:flex">
          {LINKS.map((link) => (
            <button
              key={link.href}
              type="button"
              onClick={() => go(link.href)}
              className="text-sm font-semibold text-brand-ink/80 hover:text-brand-navy"
            >
              {link.label}
            </button>
          ))}
          <button
            type="button"
            onClick={onSignIn}
            className="rounded-pill bg-brand-navy px-5 py-2.5 text-sm font-semibold text-white shadow-brand-sm transition hover:bg-brand-navy-800"
          >
            Sign in
          </button>
        </nav>

        <button
          type="button"
          className="flex h-10 w-10 items-center justify-center rounded-lg text-brand-navy md:hidden"
          onClick={() => setOpen((v) => !v)}
          aria-label={open ? 'Close menu' : 'Open menu'}
        >
          {open ? <X size={22} /> : <List size={22} />}
        </button>
      </div>

      {open && (
        <div className="border-t border-brand-line bg-white px-4 py-4 md:hidden">
          <div className="flex flex-col gap-1">
            {LINKS.map((link) => (
              <button
                key={link.href}
                type="button"
                onClick={() => go(link.href)}
                className="rounded-lg px-3 py-2.5 text-left text-sm font-semibold text-brand-ink hover:bg-brand-navy-50"
              >
                {link.label}
              </button>
            ))}
            <button
              type="button"
              onClick={() => {
                setOpen(false);
                onSignIn?.();
              }}
              className="mt-2 rounded-pill bg-brand-navy px-5 py-2.5 text-sm font-semibold text-white"
            >
              Sign in
            </button>
          </div>
        </div>
      )}
    </header>
  );
}
